export default "__VITE_ASSET__99414934__"